//https://qiita.com/yamanoku/items/027308e23cfc69845d7e
// import IntersectionObserver from 'intersection-observer-polyfill';
// let IntersectionObserver = require('intersection-observer-polyfill/dist/IntersectionObserver');

ready(() => {

    let ie = document.querySelector('body.ie');

    if (ie === null || ie.length === 0) {

        let observer = new IntersectionObserver(entries => {

            for (const e of entries) {

                //        console.log(e, e.target.tagName);

                if (e.intersectionRect.top ||
                    e.intersectionRatio > 0 ||
                    (typeof e.isIntersecting !== 'undefined' && e.isIntersecting)
                ) {

                    switch (e.target.tagName.toUpperCase()) {
                        case 'SOURCE':
                            e.target.srcset = e.target.dataset.src;
                            break;
                        case 'IMG':
                            if (e.target.classList) {
                                e.target.classList.add('lazy-loaded');
                            } else {
                                e.target.className += ' ' + 'lazy-loaded';
                            }
                            e.target.src = e.target.dataset.src;
                            break;
                    }

                    // 挿入し終わったら監視を終了
                    observer.unobserve(e.target);
                }
            }
        });


        let targets = [...document.querySelectorAll('.lazy-loading')];

        targets.forEach(obj => observer.observe(obj));

    }
});

// 監視したい要素をobserveする。
// observer.observe(document.querySelectorAll('.lazy-loading'));